import { render, staticRenderFns } from "./MaintainFamilyNotification.vue?vue&type=template&id=5ff2a347"
import script from "./MaintainFamilyNotification.vue?vue&type=script&lang=js"
export * from "./MaintainFamilyNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports